import { defineStore } from 'pinia'
import pdf from '@/api/pdf'
import authority from '@/api/authority';
import { formatDate } from '@/utils/date'
import { message } from 'ant-design-vue';

export const usePdftStore = defineStore('pdf', {
    state: () => {
        return {
            fromData: {},
            queid: null,
            spinning: false
        }
    },
    getters: {},
    actions: {
        //获取pdf
        getReport(params, router, id) {
            pdf.getReport(res => {
                if (res.code == 200) {
                    this.fromData = res.data
                }
            }, params)
        },
        //上传pdf
        postFile(params) {
            pdf.postFile(res => {
                if (res.code == 200) {
                    let params1 = {
                        queId: this.queid,
                        reportId: res.data.id,
                        stage: 10
                    }
                    this.postId(params1)
                }
            }, params)
        },
        postId(params) {
            pdf.postId(response => {
                if (response.code == 200) {
                    this.spinning = false
                }
            }, params)
        }
    },
})